import { useMemo } from 'react';
import Drawer from '../../../../../components/Drawer';

import useJurisdiction from '../../../../../hooks/useJurisdiction';
import { TableContainer, Table, TableHeader, TableBody, TableItem, SpaceBetweenBox } from './style';

export const ReadonlyReportJurisdictionDrawer = ({ isOpen, onClose, periodId, workflowId }) => {
  const { jurisdictions } = useJurisdiction({
    onClose,
    periodId,
    projectId: workflowId,
    enabledFetch: isOpen
  });

  const fcaJurisdictions = useMemo(() => {
    return jurisdictions?.filter(juris => juris.reporting_member_state === 'UK');
  }, [jurisdictions]);

  const esmaJurisdictions = useMemo(() => {
    return jurisdictions?.filter(juris => juris.reporting_member_state !== 'UK');
  }, [jurisdictions]);

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      title="Jurisdiction"
      style={{
        width: 452
      }}
    >
      <TableContainer>
        {fcaJurisdictions?.length > 0 && (
          <JurisdictionTable isFCA={true} elements={fcaJurisdictions} />
        )}

        {esmaJurisdictions?.length > 0 && (
          <JurisdictionTable isFCA={false} elements={esmaJurisdictions} />
        )}
      </TableContainer>
    </Drawer>
  );
};

const JurisdictionTable = ({ isFCA, elements }) => {
  return (
    <Table>
      <TableHeader>
        <SpaceBetweenBox>
          <p>{isFCA ? 'FCA' : 'ESMA'} jurisdictions</p>
          <span>{elements.length} jurisdiction</span>
        </SpaceBetweenBox>
      </TableHeader>

      <TableBody>
        {elements?.map(el => (
          <TableItem key={el.id}>
            <div className="toggler">
              <span>{el.country_name}</span>
            </div>
          </TableItem>
        ))}
      </TableBody>
    </Table>
  );
};
